import React, { useState, useEffect, useRef } from 'react';
import styles from './index.module.scss';

// Components
import { Modal, Form, Row, Col, Button, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint, faMoneyBillAlt } from '@fortawesome/free-solid-svg-icons';
import ErrorLabel from '../../../components/ErrorLabel';

const PaymentModal = (props) => {
    const paymentInput = useRef();
    const [owed, setOwed] = useState('');
    const [payment, setPayment] = useState('');
    const [isPaid, setIsPaid] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (!isPaid) {
            const newOwedVal = (props.total - props.paid - payment);
            if (newOwedVal >= 0 && props.total !== 0)
                setOwed(newOwedVal.toFixed(2));
            else
                setOwed(`(${Math.abs(newOwedVal).toFixed(2)})`);
        }
    }, [payment, props, isPaid]);

    useEffect(() => {
        const owedVal = (props.total - props.paid);
        if (owedVal <= 0 && props.total !== 0)
            setIsPaid(true);
    }, [props]);

    const clearInputs = () => {
        setPayment('');
        setErrorMessage('');
    }

    const makePayment = () => {
        if (+payment >= 1 && +payment <= 2000)
            props.makePayment('MAKE_PAYMENT', {
                payment: payment
            });
        else
            setErrorMessage('El pago debe ser $1.00 a $2000.00');
    }

    const onPaymentInputFocusHandler = () => {
        paymentInput.current.focus();
    }

    return (
        <Modal show={props.show} onEntered={onPaymentInputFocusHandler} onHide={props.onClose} onShow={clearInputs}>
            <Modal.Header>
                <Modal.Title>Hacer un Pago</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Total</Form.Label>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>$</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control type="text" value={props.total.toFixed(2)} readOnly />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Debe</Form.Label>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>$</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control type="text" value={owed} readOnly />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group>
                        <Form.Label>Pago Actual</Form.Label>
                        <Row>
                            <Col>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>$</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        className={styles.PaymentControl}
                                        type="text"
                                        placeholder="Ingresa valor a pagar"
                                        value={payment}
                                        onChange={(e) => setPayment(e.target.value)}
                                        ref={paymentInput} />
                                </InputGroup>
                            </Col>
                            <Col />
                        </Row>
                    </Form.Group>
                </Form>
                <ErrorLabel>{errorMessage}</ErrorLabel>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="danger"
                    size="sm"
                    onClick={props.onClose}>Cancelar</Button>
                <Button variant="secondary" size="sm" onClick={props.showReceipt}>
                    <FontAwesomeIcon className={styles.ButtonIcon} icon={faPrint} />
                    <span>Imprimir Recibo</span>
                </Button>
                <Button variant="success" size="sm" onClick={makePayment} disabled={isPaid}>
                    <FontAwesomeIcon className={styles.ButtonIcon} icon={faMoneyBillAlt} />
                    <span>Hacer Pago</span>
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default PaymentModal;